__turbopack_context__.v({
  "className": "mallory_a67afa28-module__YuT3Wa__className",
  "variable": "mallory_a67afa28-module__YuT3Wa__variable",
});
